import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { RuntimeBuildCreatePage } from '@/features/admin/runtimes/runtime-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/** Construire une version d'un runtime de l'organisation (ADR 0097). */
export const Route = createFileRoute('/$tenant/runtimes/$runtimeId/builds/new')({
  component: NewRuntimeBuildRoute,
});

function NewRuntimeBuildRoute() {
  const { tenant, runtimeId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="runtimes"
      crumbs={[
        { label: t('nav.items.runtimes') },
        { label: <EntityName tenantId={tenant} kind="runtime" id={runtimeId} /> },
        { label: t('admin.runtimes.builds.newTitle') },
      ]}
    >
      <RuntimeBuildCreatePage tenantId={tenant} runtimeId={runtimeId} />
    </ConsoleShell>
  );
}
